<script lang="ts">
  import { Component, Vue, Prop, Emit, Watch } from "vue-facing-decorator";
  import { FormSelect } from "@/components/forms";
  import { cloneDeep } from "lodash";

  @Component({
    components: {
      FormSelect,
    },
  })
  export default class FolderSelect extends Vue {
    @Prop({ required: true }) value!: any;
    @Prop({ required: true }) options!: any;
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: true }) single!: any;
    @Prop({ required: true }) activityId!: number;
    @Prop({ default: undefined }) name!: string | undefined;

    localValue: any = null;

    selectedOption: any = null;

    get wrappedName() {
      let name: string = this.localValue.media[0].name;

      if (name.length < 32) {
        return name;
      }

      return name.substring(0, 15) + " ... " + name.substring(name.length - 15, name.length);
    }

    setSelectedOption() {
      if (!this.localValue || !this.localValue.media || !this.localValue.media[0].folder) {
        return;
      }

      this.localValue.meta.folder = this.localValue.media[0].folder;
      this.localValue.type = this.localValue.media[0].type;

      // If the file has not a suggested type,
      // select the folder as the type
      if (!this.localValue.type) {
        this.selectedOption = this.options.find((f: any) => f.value === this.localValue.meta.folder);
        return;
      }

      this.selectedOption = this.options.find((f: any) => f.value === this.localValue.type && f.type === "placeholder");
    }

    handleValueChange(option: any) {
      this.localValue.activity_id = this.activityId;

      if (option.type === "placeholder") {
        this.localValue.type = option.value;
        this.localValue.name = option.label;
        this.localValue.meta.folder = option.folder;
        this.localValue.media[0].folder = option.value;
      } else if (option.type === "folder") {
        this.localValue.type = null;
        this.localValue.name = option.label;
        this.localValue.meta.folder = option.value;
        this.localValue.media[0].folder = option.value;
      }

      this.emitValue();
    }

    @Emit("input")
    emitValue() {
      return this.localValue;
    }

    @Watch("value", { deep: true, immediate: true })
    handleValueChanged(newValue: any) {
      this.localValue = cloneDeep(newValue);

      this.setSelectedOption();

      if (this.localValue.type) {
        this.localValue.name = this.$t(`views.documents.placeholders.${this.localValue.type}`) as string;
      }

      if (!this.localValue.name) {
        this.localValue.name = this.localValue.media[0].name;
      }
    }
  }
</script>

<template>
  <div class="grid gap-2" :class="{ 'grid-cols-2': !single }">
    <div v-if="!single" class="text-14 flex items-center">{{ wrappedName }}</div>
    <form-select
      :disabled="disabled"
      :options="options"
      v-model="selectedOption"
      @input="handleValueChange"
      :clearable="false"
      :searchable="true"
      :name="name || 'folder'"
      placeholder="Kies een folder of placeholder"
      rules="required"
      :reduce="(o) => o"
    ></form-select>
  </div>
</template>
